import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";


import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";
import Select from "react-select";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addQuestionnaireText, editQuestionnaireText } from "store/actions";
import { fetchQuestionList } from "helpers/backend_api_helper";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";


const TextAddEditModal = props => {
    const { modal, toggle, isEdit, itemData, SetItemData, fetchQuestionnaireTextListData, AspirationId } = props
    const [questionnaireTextData, setQuestionnaireTextData] = useState();
    const [questionList, setQuestionList] = useState()
    const { state } = useLocation();

    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.Questionnaire.loading,
        error: state.Questionnaire.error,
        success: state.Questionnaire.success,
        editLoading:state?.Questionnaire?.editLoading
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setQuestionnaireTextData(itemData)
    }, [itemData]);


    // fetch language
    const fetchQuestionLists = async () => {
        try {
            const listQuestion = await fetchQuestionList();
            setQuestionList(listQuestion?.data)
        } catch (error) {

        }

    }

    useEffect(() => {
        fetchQuestionLists()
    }, [])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            question_id: questionnaireTextData?.question_id || '',
            is_active: questionnaireTextData?.is_active || 'Y'
        },
        validationSchema: Yup.object({
            // question_id: Yup.string().required(props.t("Please Enter Question")),
            is_active: Yup.string().required(props.t("Please Enter Text Status")),
        }),
        onSubmit: (values, { resetForm }) => {
            values = {
                ...values,
                questionnaire_id: state?.questionnaireData?.id,
                question_id: selectValue?.value
            }

            if (isEdit) {

                dispatch(editQuestionnaireText(values, questionnaireTextData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            questionnaire_id: '',
                            is_active: ''
                        });
                        fetchQuestionnaireTextListData();
                        setSelectValue()
                        toggle()

                    } else {
                        toastr.error(res.message || "Something Went Wrong.")
                        setSelectValue()
                        toggle()
                        
                    }
                }));
            } else {
                dispatch(addQuestionnaireText(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        
                        resetForm({
                            questionnaire_id: '',
                            is_active: ''
                        });
                        fetchQuestionnaireTextListData()
                        toastr.success(res.message)
                        setSelectValue()
                        toggle()
                    } else {
                        toastr.error(res?.message || "Something Went Wrong.")
                        setSelectValue()
                        toggle()
                        
                    }
                }));
            }
        }
    });
    const [options, setoptions] = useState([]);
    const [selectValue, setSelectValue] = useState()

    useEffect(() => {
        if (isEdit) {
            setSelectValue(
                {
                    value: questionnaireTextData?.question_id,
                    label: questionnaireTextData?.question,
                }
            )
        }
        let modifiedList = questionList?.map(dky => ({
            value: dky.id,
            label: dky.question,
        }))
        setoptions(modifiedList)
    }, [questionList, questionnaireTextData])
    const handleSelectChange = (obj) => {
        setSelectValue(obj)
    }


    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    SetItemData()
                    setSelectValue()
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        SetItemData()
                        setSelectValue()

                    }}>
                    {!!isEdit ? props.t("Edit Questionnaire Aspiration") : props.t("Add Questionnaire Aspiration")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        {
                            itemData
                            &&
                            <div className="mb-3 d-block">
                                <Label className="form-label m-0 pb-1">{props.t("Schor Concept id")}: </Label>
                                <span style={{ fontSize: "15px", fontWeight: "bold" }}> {itemData?.questionnaire_name || AspirationId}</span>
                            </div>
                        }

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Aspiration ID")}:</Label>
                            <Select
                                className="custom-select-search-option"
                                options={options}
                                value={selectValue}
                                name="question_id"
                                onChange={handleSelectChange}
                            />
                            {/* <Input
                                name="question_id"
                                className="form-control"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.question_id || ""}
                                invalid={
                                    validation.touched.question_id && validation.errors.question_id ? true : false
                                }
                            >
                                <option value="" disabled>{props.t("Select Question")}</option>
                                {
                                    questionList?.map((data, key) => {
                                        return (
                                            <option key={key} value={data?.id}>{`${data?.question} (${data?.question_type})`}</option>
                                        )
                                    })
                                }
                            </Input>
                            {validation.touched.question_id && validation.errors.question_id ? (
                                <FormFeedback type="invalid">{validation.errors.question_id}</FormFeedback>
                            ) : null} */}
                        </div>

                        <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="active"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y' ? true : false}
                                    value="Y"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="active" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="inactive"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N' ? true : false}
                                    value="N"
                                    type="radio"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="inactive" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div>


                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }

                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


TextAddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(TextAddEditModal);
